import ServiceBase from '../ServiceBase';

export default class ProjectsAdminService extends ServiceBase {

    searchProjects(creatorID, filters = {}, pageSize = null, pageIndex = null) {
        const params = {
            creatorID,
            pageSize,
            pageIndex,
            ...filters || {},
        };

        return this.request('post', 'admin/projects/searchProjects', params);
    }

    enableStablePledge({
        projectID,
        awarenessCannotDeactivatedStablePledge,
        agreementToAdditionalSection,
        declareToShowTheEstimatedPrice,
        confirmBackersPossibilityToRefund,
    }) {
        return this.request('post', 'admin/projects/enableStablePledge', {
            projectID,
            awarenessCannotDeactivatedStablePledge,
            agreementToAdditionalSection,
            declareToShowTheEstimatedPrice,
            confirmBackersPossibilityToRefund,
        });
    }

    confirmTaxRates({
        projectID,
        declareResponsibility,
        taxVerified,
    }) {
        return this.request('post', 'admin/projects/confirmTaxRates', {
            projectID,
            declareResponsibility,
            taxVerified,
        });
    }

    cancelCampaign({
        projectID,
        isIrreversibleActionConfirmed,
        isChangesBlockingActionConfirmed,
        isUpdatePostPublishedConfirmed,
        reason,
        password,
    }) {
        return this.request('post', 'admin/projects/cancelCampaign', {
            projectID,
            isIrreversibleActionConfirmed,
            isChangesBlockingActionConfirmed,
            isUpdatePostPublishedConfirmed,
            reason,
            password,
        });
    }

    getProjectDescriptionSectionsToCopy(copyFrom, copyTo, projectID) {
        const params = {
            copyFrom,
            copyTo,
            projectID,
        };
        return this.request('post', 'admin/projects/getProjectDescriptionSectionsToCopy', params);
    }

    copyProjectDescriptions(copyTo, projectDescriptionSectionsIDs, projectID) {
        const params = {
            copyTo, projectDescriptionSectionsIDs, projectID,
        };
        return this.request('post', 'admin/projects/copyProjectDescriptions', params);
    }

    getProjectAdditionalInfo(projectID) {
        return this.request('get', 'admin/projects/getProjectAdditionalInfo', { params: { projectID } });
    }

    getAvailableProjectBackupPaymentMethods({ projectID }) {
        return this.request('get', 'admin/projectBackupPaymentMethod/getAvailableProjectBackupPaymentMethods', { projectID });
    }

    getProjectBackupPaymentMethodData({ projectID }) {
        return this.request('get', 'admin/projectBackupPaymentMethod/getProjectBackupPaymentMethodData', { projectID });
    }

    saveProjectBackupPaymentMethod(paymentModel, projectID) {
        const model = {
            projectID,
            ...paymentModel,
        };

        return this.request('post', 'admin/projectBackupPaymentMethod/saveProjectBackupPaymentMethod', model);
    }

    authorizeProjectBackupPaymentMethod(paymentModel, projectID, providerPaymentID) {
        const model = {
            projectID,
            providerPaymentID,
            ...paymentModel,
        };

        return this.request('post', 'admin/projectBackupPaymentMethod/authorizeProjectBackupPaymentMethod', model);
    }

    getProjectFinancialDetails(projectID) {
        return this.request('get', 'admin/projects/getProjectFinancialDetails', { projectID });
    }

    updateProjectFinancialDetails(model) {
        return this.request('post', 'admin/projects/updateProjectFinancialDetails', model);
    }

    getProjectNote(projectID) {
        return this.request('get', 'admin/projects/getProjectNote', { projectID });
    }

    updateProjectNote(note, projectID) {
        return this.request('post', 'admin/projects/updateProjectNote', { note, projectID });
    }

    getProjectFacts(projectID) {
        return this.request('get', 'admin/projects/getProjectFacts', { projectID });
    }

    closePledgeManager(projectID) {
        return this.request('post', 'admin/projects/closePledgeManager', { projectID });
    }

    getTimelineSettings(projectID) {
        return this.request('get', 'admin/projects/getTimelineSettings', { projectID });
    }

    updateTimelineSettings(model) {
        return this.request('post', 'admin/projects/updateTimelineSettings', model);
    }

    getAvailableProjects(options = {}) {
        const {
            pageIndex = 0,
            pageSize = 20,
            searchTerm = null,
            creatorID = null,
            projectID = null,
        } = options;

        return this.request('post', 'admin/projects/getAvailableProjects', {
            pageIndex,
            pageSize,
            searchTerm,
            creatorID,
            projectID,
        });
    }

    getTrackingSettings(projectID) {
        return this.request('get', 'admin/projects/getTrackingSettings', { params: { projectID } });
    }

    updateTrackingSettings(settings) {
        return this.request('post', 'admin/projects/updateTrackingSettings', settings);
    }

    validateMetaConversionApiToken(projectID) {
        return this.request('get', 'admin/projects/validateMetaConversionApiToken', { projectID });
    }
}
